export const logos = "https://solucoes.sinsoft.com.br/api/enderecos/"